<template>
  <tr v-if="banner">
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <p class="text-gray-900 whitespace-no-wrap">{{ banner.name }}</p>
      <p class="text-xs">{{ new Date(banner.datecreation).toLocaleDateString('fr') }}</p>
    </td>

    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <div class="fields-container">
        <div class="relative">
          <button class="rounded bg-gray-200 button-field font-semibold" v-on:click="(e) => {copyFieldToClipBoard(e, banner.code)}">
            {{ banner.code }}
          </button>
          <div class="copy-popin">Copied !</div>
        </div>
      </div>
    </td>

    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <span
        class="relative inline-block px-3 py-1 font-semibold leading-tight"
        :class="{
          'text-green-900': banner.status === 'enable' || banner.status === 'pending' || banner.status === 'terminated',
          'text-gray-900': banner.status === 'disable'
      }">
        <span aria-hidden
              class="absolute inset-0 opacity-50 rounded"
              :class="{
                'bg-green-200': banner.status === 'enable' || banner.status === 'pending' || banner.status === 'terminated',
                'bg-gray-200': banner.status === 'disable'
        }"></span>
        <span class="relative">
          <template v-if="banner.status === 'enable'">Enable</template>
          <template v-else-if="banner.status === 'pending'">Pending</template>
          <template v-else-if="banner.status === 'terminated'">Terminated</template>
          <template v-else>Disable</template>
        </span>
      </span>
    </td>

    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <p class="text-gray-900 whitespace-no-wrap">{{ banner.target_audience }}</p>
    </td>

    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <p class="text-gray-900 whitespace-no-wrap">
        <template v-if="banner.url_target_list.includes('.*')">Every where on <br>{{ banner.url }}</template>
        <template v-else>
          <span
            class="relative inline-block px-3 py-1 text-gray-900 leading-tight">
            <span aria-hidden
                  class="absolute inset-0 bg-gray-200 opacity-50 rounded"></span>
            <span class="relative">{{ banner.url_target_string }}</span>
        </span> on <br>{{ banner.url }}</template>
      </p>
    </td>
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <p class="text-gray-900 whitespace-no-wrap">
        <span v-if="banner.frequencylimitation === 'none' && banner.frequencylimitationvalue === 1">Show every time</span>
        <span v-if="banner.frequencylimitation === 'none' && banner.frequencylimitationvalue === 0">Only manually</span>
        <span v-if="banner.frequencylimitation !== 'none' && banner.frequencylimitationvalue > 0">Show {{ banner.frequencylimitationvalue }} times per {{ banner.frequencylimitation }}</span>
        <span v-if="banner.frequencylimitation !== 'none' && banner.frequencylimitationvalue === 0">Can't show</span>

        <span v-if="banner.activationdate && banner.deactivationdate">between {{ _getDate(banner.activationdate, site.timezone) | date }} and {{ _getDate(banner.deactivationdate, site.timezone) | date }}</span>
      </p>
    </td>
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-center">
      <p class="text-gray-900 whitespace-no-wrap">
        <span v-for="(view, index) in viewsUnique" :key="view.id">
          <span v-if="view.id === banner.id">
            {{ view.views }}&nbsp;
            <font-awesome-icon icon="eye" @click="openPopup(index)"></font-awesome-icon>
            <banners-ui-modal-stats  v-if="isOpenTableGiven[index]" :open="isOpenTableGiven[index]" :site="site" :close="closeTable" :id="banner.id" />
          </span>
        </span>
      </p>
    </td>

    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
      <router-link  class="cursor-pointer text-gray-600 bg-gray-200 rounded p-2" :to="{ name: 'BannerEdit', params: {site: site.sitekey, id: banner.id } }">
        <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
      </router-link>
      <a
        class="cursor-pointer text-gray-600 bg-gray-200 rounded p-2"
        @click="duplicateBanner">
        <font-awesome-icon icon="clone"></font-awesome-icon>
      </a>
      <a
        @click="confirmDeletion"
        class="cursor-pointer text-gray-600 bg-gray-200 rounded p-2">
        <font-awesome-icon icon="trash"></font-awesome-icon>
      </a>
      <modal-confirmation
        v-if="deleteBannerModalConfirmation"
        :open="deleteBannerModalConfirmation"
        type="danger"
        messageTitle="Warnings !"
        message="Do you really want to remove this banner ? This actions cannot be undone."
        messageAction="Yes, I'm sure !"
        @execute="deleteBanner"
        @close='deleteBannerModalConfirmation = false' />
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ModalConfirmation from '@/components/others/utils/ModalConfirmation.vue'

export default {
  name: 'BannerUiItemList',

  components: { ModalConfirmation },

  props: {
    bannerId: {
      type: String,
      required: true
    },
    isOpenTableGiven: {
      type: Array,
      required: true
    },
    viewsUnique: {
      required: true
    },
    banners: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      isOpenTable: this.isOpenTableGiven,
      deleteBannerModalConfirmation: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('banners', {
      getById: 'getById'
    }),
    banner () {
      return this.getById(this.bannerId)
    }
  },
  methods: {
    ...mapActions('banners', ['removeBanner', 'addBanner']),

    copyFieldToClipBoard(e, field) {
      navigator.clipboard.writeText(field)
      e.target.classList.add("active");
      setTimeout(() => {
        e.target.classList.remove("active")
      }, 1000)
    },

    openPopup (index) {
      this.isOpenTableGiven[index] = true
      this.$forceUpdate()
    },
    closeTable () {
      for (let i = 0; i < this.isOpenTableGiven.length; ++i) {
        this.isOpenTableGiven[i] = false
      }
      this.$forceUpdate()
    },
    duplicateBanner () {
      let bannerClone = Object.assign({}, this.banner)

      bannerClone.status = 'disable'
      bannerClone.name = 'Copy of ' + bannerClone.name

      if (bannerClone.reward && bannerClone.reward !== null && !bannerClone.reward.length) bannerClone.reward = null

      this.addBanner({
        banner: bannerClone
      })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.banner.duplicated'),
            type: 'success'
          })
          let bannerCreated = this.banners.pop();
          this.banners.splice(0, 0, bannerCreated);
        })
        .catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.data.code + '.title'),
            message: this.$root.$t('api.' + response.data.code + '.message')
          })
        })
    },

    confirmDeletion () {
      this.deleteBannerModalConfirmation = true
    },

    deleteBanner () {
      this.removeBanner({ banner: this.banner })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.banner.deleted'),
            type: 'success'
          })
        })
        .catch((response) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.data.code + '.title'),
            message: this.$root.$t('api.' + response.data.code + '.message')
          })
        })
    },

    mounted () {
      this.init()
    }
  }
}
</script>

<style>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 46%;
  }

  .fields-container{
    display: flex;
    gap: 10px 16px;
    flex-flow: row wrap;
  }

  .button-field {
    padding: 4px 8px;
  }

  .copy-popin {
    display: none;
    z-index: 10;
    position: absolute;
    top: -36px;
    left: 50%;
    width: 70px;
    box-sizing: border-box;
    margin-left: -35px;
    padding: 4px 8px;
    text-align: center;
    border-radius: 0.25rem;
    background-color: #f59e0b;
    color: #fff;
  }

  .button-field.active ~ .copy-popin {
    display: block;
    animation: 1s linear pop;
    transform: scale(0);
  }

  @keyframes pop {
    from { transform: scale(0.5); }
    10%   { transform: scale(1); }
    90%   { transform: scale(1); }
    to { transform: scale(0.5); }
  }
</style>



// WEBPACK FOOTER //
// src/components/banners/ui/item-list.vue